export default "__VITE_ASSET__C8AWRr3k__"